import { useStyle } from "@/classify"
import { useNavigation } from "@/hooks/Navigation/useNavigation"
import React, { Suspense } from "react"
import { FocusScope } from "react-aria"
import CategoryTree from "../CategoryTree"
import LoadingIndicator from "../LoadingIndicator"
import { Portal } from "../Portal"
import defaultClasses from "./navigation.module.css"
const AuthModal = React.lazy(() => import("../AuthModal"))

const Navigation = (props) => {
  const {
    catalogActions,
    categoryId,
    handleBack,
    handleClose,
    hasModal,
    isOpen,
    isTopLevel,
    setCategoryId,
    showCreateAccount,
    showForgotPassword,
    showMainMenu,
    showMyAccount,
    showSignIn,
    view,
  } = useNavigation()

  const classes = useStyle(defaultClasses, props.classes)
  const rootClassName = isOpen ? classes.root_open : classes.root
  const maskClassName = isOpen ? classes.mask_open : classes.mask
  const modalClassName = hasModal ? classes.modal_open : classes.modal
  const bodyClassName = hasModal ? classes.body_masked : classes.body
  const tabIndex = isOpen ? "0" : "-1"

  // Lazy load the auth modal because it may not be needed.
  const authModal = hasModal ? (
    <Suspense fallback={<LoadingIndicator />}>
      <AuthModal
        closeDrawer={handleClose}
        showCreateAccount={showCreateAccount}
        showForgotPassword={showForgotPassword}
        showMainMenu={showMainMenu}
        showMyAccount={showMyAccount}
        showSignIn={showSignIn}
        view={view}
      />
    </Suspense>
  ) : null

  return (
    <Portal>
      {/* eslint-disable-next-line jsx-a11y/no-autofocus */}
      <FocusScope contain={isOpen} restoreFocus autoFocus>
        {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
        <div className={maskClassName}>
          <aside className={rootClassName}>
            <div className={bodyClassName}>
              <CategoryTree
                categoryId={categoryId}
                onNavigate={handleClose}
                setCategoryId={setCategoryId}
                updateCategories={catalogActions.updateCategories}
                tabIndex={tabIndex}
              />
            </div>
            <div className={modalClassName}>{authModal}</div>
          </aside>
        </div>
      </FocusScope>
    </Portal>
  )
}

export default Navigation
